import { conTransiciones } from './tourUi'

// ui: null = nada abierto | 'extras' = barra desplegada | 'notif' = barra + panel de notificaciones
export function getHomeSteps({ t, setUi }) {
  const steps = [
    {
      popover: { title: t('tour_home_bienvenida_t'), description: t('tour_home_bienvenida_d') }
    },
    {
      element: '[data-tour="home-periodo"]',
      popover: { title: t('tour_home_periodo_t'), description: t('tour_home_periodo_d'), side: 'bottom' }
    },
    {
      element: '[data-tour="home-ingresos"]',
      popover: { title: t('tour_home_ingresos_t'), description: t('tour_home_ingresos_d'), side: 'bottom' }
    },
    {
      element: '[data-tour="home-gastos"]',
      popover: { title: t('tour_home_gastos_t'), description: t('tour_home_gastos_d'), side: 'bottom' }
    },
    {
      element: '[data-tour="home-balance"]',
      popover: { title: t('tour_home_balance_t'), description: t('tour_home_balance_d'), side: 'top' }
    },
    {
      element: '[data-tour="home-ahorro"]',
      popover: { title: t('tour_home_ahorro_t'), description: t('tour_home_ahorro_d'), side: 'top' }
    },
    {
      element: '[data-tour="home-renta"]',
      popover: { title: t('tour_home_renta_t'), description: t('tour_home_renta_d'), side: 'top' }
    },
    {
      element: '[data-tour="home-herramientas"]',
      popover: { title: t('tour_home_herr_t'), description: t('tour_home_herr_d'), side: 'bottom' }
    },
    {
      element: '[data-tour="home-extras-btn"]',
      popover: { title: t('tour_home_extras_t'), description: t('tour_home_extras_d'), side: 'bottom' }
    },
    {
      ui: 'extras',
      element: '[data-tour="home-notif-btn"]',
      popover: { title: t('tour_home_notif_t'), description: t('tour_home_notif_d'), side: 'bottom' }
    },
    {
      ui: 'notif',
      element: '[data-tour="home-notif-panel"]',
      popover: { title: t('tour_home_panel_t'), description: t('tour_home_panel_d'), side: 'bottom' }
    },
    {
      ui: 'extras',
      element: '[data-tour="home-alertas-btn"]',
      popover: { title: t('tour_home_alertas_t'), description: t('tour_home_alertas_d'), side: 'bottom' }
    },
    {
      ui: 'extras',
      element: '[data-tour="home-perfil-btn"]',
      popover: { title: t('tour_home_perfil_t'), description: t('tour_home_perfil_d'), side: 'bottom' }
    },
    {
      element: '[data-tour="home-nav"]',
      popover: { title: t('tour_home_nav_t'), description: t('tour_home_nav_d'), side: 'top' }
    }
  ]
  return conTransiciones(steps, setUi)
}